
import api from "../../api";

export const getNotifications = async (data : {
    type ?: string | null,
    page ?: number,
    page_size ?: number,
    unread ?: boolean, 

}) => {
    const res : any = await api.get("notifications/", { params : data })
    return res.data
}

export const acceptInvite = async (data : {
    id : string,
    notificationId : string,
}) => {
    const res : any = await api.put(`events/${data.id}/join/`)
    return res.data
}

export const declineInvite = async (data : {
    id : string,
}) => {
    const res : any = await api.put(`notifications/${data.id}/decline/`)
    return res.data
}

export const getUpcomingEvents = async (data : {
    min_date ?: string,
    max_date ?: string,
    page : number,
    page_size : number,
    has_healthkit_data ?: boolean,
}) => {
    const res : any = await api.get("events/bookings/", { params : data })
    return res.data
}

export const deleteJoin = async (data : {
    id : string,
}) => {
    const res : any = await api.delete(`events/${data.id}/join/`)
    return res.data
}

export const getSuggestedEvents = async (data : { id : string}) => {
    const res : any = await api.get(`events/${data.id}/alternatives/`)
    return res.data
}

export const patchSwitchEvent = async ({ id , data }: { id : string, data : {
    to_event_id : string
}}) => {
    const res : any = await api.patch(`events/${id}/join/`, data)
    return res.data
}

export const postInvite = async ( { id , data } : { id : string, data : {
    member : string,
}}) => {
    const res : any = await api.post(`events/${id}/invite/`, data)
    return res.data
}

export const postCoachInvite = async ( { id , data } : { id : string, data : {
    member : string,
}}) => {
    const res : any = await api.post(`coach/${id}/invite/`, data)
    return res.data
}

export const deletePrivateClass = async (data : {
    id : string,
}) => {
    const res : any = await api.delete(`private_classes/bookings/${data.id}/`)
    return res.data
}

export const switchPrivateClass = async (data : {
    id : string,
    to : string,
}) => {
    const res : any = await api.patch(`private_classes/bookings/${data.id}/`, {
        to : data.to
    })
    return res.data
}